module.exports = __webpack_public_path__ + "static/img/LOGO.cbb7cae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LOGO.png
// module id = /+5v
// module chunks = 1